import styled from "styled-components";
import fipayFonts from "../../../theme/index";
import { colors } from "../../../theme/color";

export const LinkTypeContainer = styled.div<{ $hasBorder?: boolean }>`
  width: 280px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: ${({ $hasBorder }) => ($hasBorder ? "1px solid #f0f2f4" : "none")};
  border-radius: ${({ $hasBorder }) => ($hasBorder ? "15px" : "")};
  @media screen and (max-width: 430px) {
    width: 280px;
  }

  @media screen and (max-width: 327px) {
    width: 280px;
  }
`;

export const LinkType = styled.div<{ $center?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: ${({ $center }) => ($center ? "center" : "flex-start")};
  gap: 5px;
  padding: ${({ $center }) => ($center ? "12px" : "none")};
  margin-bottom: ${({ $center }) => ($center ? "" : "20px")};
  @media screen and (max-width: 430px) {
  }

  @media screen and (max-width: 327px) {
  }
`;
export const RadioButton = styled.div`
  width: 16px;
  height: 16px;
  display: inline-flex;
  padding-top: 4px;
  justify-content: center;
  align-items: center;
`;

export const RadioLabelContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
`;

export const RadioLabel = styled.div<{ $textColor?: boolean }>`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  color: ${({ $textColor }) => ($textColor ? "#5e5e5e" : `${colors.BLACK}`)};
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Description = styled.div`
  text-align: left;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  color: #868686;
  @media screen and (max-width: 768px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  }
`;
